import { FunctionComponent, ReactNode, useState } from 'react';

interface ImgProps {
  urls: string[];
  alt: string;
  fallback?: ReactNode;
}

const Img: FunctionComponent<ImgProps> = ({ urls, alt, fallback }) => {
  const [failedUrls, setFailedUrls] = useState<string[]>([]);

  const firstAlternative = urls.find(
    (url) => !!url && !failedUrls.includes(url),
  );

  if (!firstAlternative) {
    return <>{fallback}</>;
  }

  return (
    <img
      alt={alt}
      src={firstAlternative}
      onError={() => setFailedUrls((current) => [...current, firstAlternative])}
    />
  );
};

export default Img;
